import { render, staticRenderFns } from "./AppRadioCards.vue?vue&type=template&id=bba317ca&scoped=true&"
import script from "./AppRadioCards.vue?vue&type=script&setup=true&lang=js&"
export * from "./AppRadioCards.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AppRadioCards.vue?vue&type=style&index=0&id=bba317ca&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bba317ca",
  null
  
)

export default component.exports